const StyleVariables = {
	$med_width: '768px',
	$main_content_max_width: '88%',
	$xlarge: 'only screen and (min-width: 1280px)',
	$med: 'only screen and (max-width: 1080px)',
	$medSmall: 'only screen and (max-width: 991px)',
	$small: 'only screen and (max-width: 767px)',
	$smaller: 'only screen and (max-width: 600px)',
	$xsmall: 'only screen and (max-width: 467px)',
}

export const StyleBreakpoints = {
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200,
}

export default StyleVariables
